import { getInitialTheme } from "./_theme-core";

document.documentElement.dataset.bsTheme = getInitialTheme();
